/**
 * Funções de validação para Roadmap
 */
import { VALIDATION_TYPES } from './types';

export function validateHeaders(headers) {
  const requiredHeaders = ['Nome', 'Nível', 'Status'];
  return requiredHeaders.filter(header => !headers.includes(header));
}

export function generateHeaderError(missingHeaders, headers) {
  let errorMessage = `❌ Erro na estrutura do arquivo:\n`;
  errorMessage += `\n🔍 Colunas obrigatórias faltando:\n`;
  missingHeaders.forEach(header => {
    errorMessage += `• ${header}\n`;
  });
  errorMessage += `\n📋 Colunas encontradas no arquivo:\n`;
  headers.forEach(header => {
    errorMessage += `• ${header}\n`;
  });
  // Só mostra as colunas opcionais se não houver colunas obrigatórias faltando
  if (missingHeaders.length === 0) {
    errorMessage += `\n💡 Colunas opcionais: Data de Inicio, Previsão de Entrega, Data de Conclusão`;
  }
  return errorMessage;
}

export function generateValidationError(validationErrors) {
  let errorMessage = `❌ Encontrados ${validationErrors.length} erro(s) no arquivo:\n`;
  
  // Agrupar erros por tipo
  const errorsByType = validationErrors.reduce((acc, error) => {
    acc[error.type] = acc[error.type] || [];
    acc[error.type].push(error);
    return acc;
  }, {});

  // Resumo dos tipos de erro
  const errorTypeDescriptions = {
    'missing_name': 'campo Nome vazio',
    'missing_level': 'campo Nível vazio',
    'invalid_level': 'nível inválido',
    'orphan_subitem': 'subitem órfão',
    'missing_status': 'campo Status vazio',
    'invalid_status': 'status inválido',
    'missing_data_inicio': 'Data de Início obrigatória (status Concluído)',
    'missing_previsao_entrega': 'Previsão de Entrega obrigatória (status Concluído)',
    'missing_data_conclusao': 'Data de Conclusão obrigatória (status Concluído)',
    'invalid_data_conclusao': 'Data de Conclusão inválida',
    'invalid_data_inicio_format': 'Data de Início com formato inválido',
    'invalid_previsao_entrega_format': 'Previsão de Entrega com formato inválido',
    'invalid_data_conclusao_format': 'Data de Conclusão com formato inválido'
  };

  Object.entries(VALIDATION_TYPES).forEach(([key, value]) => {
    if (errorsByType[value.type]) {
      const description = errorTypeDescriptions[value.type] || value.type;
      errorMessage += `• ${errorsByType[value.type].length} linha(s) com ${description}\n`;
    }
  });

  // Detalhes específicos dos erros
  errorMessage += `\n🔍 Detalhes dos erros:\n`;
  validationErrors.slice(0, 10).forEach(error => {
    errorMessage += `• ${error.message}\n`;
  });
  if (validationErrors.length > 10) {
    errorMessage += `• ... e mais ${validationErrors.length - 10} erro(s)\n`;
  }

  return errorMessage;
}
